///store/homeStore.js
import { defineStore } from 'pinia'

export const useHomeStore = defineStore('homeStore', {
    state: () => ({
        isLoaded: false,       // 是否已經撈過資料
        carouselBanners: [],
        usersTestimonials: [],
        certificates: [],
        usersBEs: [],
        //hotProducts: [],
        //newProducts: [],
        homeProducts : [],
        home_001: "",
        home_002: "",
        report_001: "",
    }),
    actions: {
        async fetchHomeData() {
            const homeVersion = localStorage.getItem('homeVersion') ? localStorage.getItem('homeVersion') : null //商品與購物車
            const homeProductsVersion = localStorage.getItem('homeProductsVersion') ? localStorage.getItem('homeProductsVersion') : null //購物車清單
            if (this.isLoaded) return // 已載入過就直接 return
            try {
                const res = await fetch('/api/load/homepage',
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ homeVersion , homeProductsVersion }),
                    }
                )
                const json = await res.json()
                if (json.success) {
                    if (json.isPageUpdated) {
                        this.carouselBanners = json.banners
                        this.usersTestimonials = json.usersTestimonials
                        this.usersBEs = json.usersBEs
                        this.certificates = json.certificates
                        this.home_001 = json.home_001
                        this.home_002 = json.home_002
                        this.report_001 = json.report_001
                        localStorage.setItem('SAVE_carouselBanners', JSON.stringify(json.banners))
                        localStorage.setItem('SAVE_usersTestimonials', JSON.stringify(json.usersTestimonials))
                        localStorage.setItem('SAVE_usersBEs', JSON.stringify(json.usersBEs))
                        localStorage.setItem('SAVE_certificates', JSON.stringify(json.certificates))
                        localStorage.setItem('home_001', json.home_001)
                        localStorage.setItem('home_002', json.home_002)
                        localStorage.setItem('report_001', json.report_001)
                        localStorage.setItem('homeVersion', json.serverHomeVersion)
                    } else {
                        const savedBanners = localStorage.getItem('SAVE_carouselBanners')
                        const savedTestimonials = localStorage.getItem('SAVE_usersTestimonials')
                        const savedBEs = localStorage.getItem('SAVE_usersBEs')
                        const savedCertificates = localStorage.getItem('SAVE_certificates')
                        const savedHome001 = localStorage.getItem('home_001')
                        const savedHome002 = localStorage.getItem('home_002')
                        const savedReport001 = localStorage.getItem('report_001')
                        this.carouselBanners = savedBanners ? JSON.parse(savedBanners) : []
                        this.usersTestimonials = savedTestimonials ? JSON.parse(savedTestimonials) : []
                        this.usersBEs = savedBEs ? JSON.parse(savedBEs) : []
                        this.certificates = savedCertificates ? JSON.parse(savedCertificates) : []
                        this.home_001 = savedHome001 || ''
                        this.home_002 = savedHome002 || ''
                        this.report_001 = savedReport001 || ''
                    }
                    if(json.isProductUpdated){
                        this.homeProducts = json.homeProducts
                        localStorage.setItem('SAVE_homeProducts', JSON.stringify(json.homeProducts))
                        localStorage.setItem('homeProductsVersion', json.serverCartVersion)
                    }else{
                        const savedHomeProducts = localStorage.getItem('SAVE_homeProducts')
                        this.homeProducts = savedHomeProducts ? JSON.parse(savedHomeProducts) : []

                    }
                    this.isLoaded = true  // 標記為「已載入」
                } else {
                    console.warn('取得fetchHomeData失敗', json.message)
                }
            } catch (err) {
                console.error('fetch error:', err)
            }
        },
    },
})
